import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../resource/image/clabil-logo.png';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Handle scroll for elite feel
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const navItems = [
    { name: '문의하기', path: '/contact' },
  ];

  const handleNavigate = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 font-pretendard
                ${scrolled ? 'bg-white/80 backdrop-blur-md shadow-sm h-16 md:h-20' : 'bg-white h-16 md:h-20'}
                flex items-center border-b border-clabil-border-light`}
    >
      <div className="container mx-auto h-full flex items-center justify-between">
        {/* Logo */}
        <div
          className="flex items-center cursor-pointer transition-transform hover:scale-105"
          onClick={() => handleNavigate('/')}
        >
          <img
            src={logo}
            alt="CLABIL Logo"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          {navItems.map((item) => (
            <button
              key={item.path}
              onClick={() => handleNavigate(item.path)}
              className={`text-lg font-medium transition-colors hover:text-clabil-primary
                                ${location.pathname === item.path ? 'text-clabil-primary font-bold' : 'text-clabil-text-primary'}`}
            >
              {item.name}
            </button>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center">
          <button
            onClick={toggleMenu}
            className="text-clabil-text-primary p-2 focus:outline-none"
          >
            {isMenuOpen ? <X className="w-8 h-8" /> : <Menu className="w-8 h-8" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Dropdown */}
      <div
        className={`absolute top-full left-0 w-full bg-white border-b border-clabil-border-light shadow-lg transition-all duration-300 overflow-hidden md:hidden
                    ${isMenuOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0 pointer-events-none'}`}
      >
        <div className="flex flex-col p-6 space-y-4">
          {navItems.map((item) => (
            <button
              key={item.path}
              onClick={() => handleNavigate(item.path)}
              className={`text-left text-lg font-medium py-2 transition-colors
                                ${location.pathname === item.path ? 'text-clabil-primary font-bold' : 'text-clabil-text-primary'}`}
            >
              {item.name}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
